import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitRatingResponse} from '../../model/unit-rating-response';
import { ScheduleLineDrivePackageComponent } from '../schedule-line-drive-package/schedule-line-drive-package.component';


@Component({
    selector: 'app-drive-package-wrapper',
    templateUrl: './drive-package-wrapper.component.html',
    styleUrls: ['./drive-package-wrapper.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ScheduleLineDrivePackageComponent]
})
export class DrivePackageWrapperComponent implements OnChanges {

  readonly response = input.required<UnitRatingResponse>();

  ngOnChanges(changes: SimpleChanges): void {
  }

}
